import { PaymentMethodType } from "../enums/global.enums";

export function paymentMethodPipe(value: string) {
    switch (value) {
        case PaymentMethodType.All: return "Tất cả";
        case PaymentMethodType.Bank: return "Trừ nợ qua tài khoản ngân hàng";
        case PaymentMethodType.CentralPaid: return "Thanh toán tại điểm thu";
        case PaymentMethodType.HomePay: return "Thanh toán tại nhà";
        case PaymentMethodType.EWallet: return "Ví điện tử";
        case PaymentMethodType.Manual: return "Nộp trực tiếp";
        case PaymentMethodType.Transfer: return "Chuyển khoản";
        case PaymentMethodType.Debtminusdeposit: return "Gạch nợ trừ cọc";
        case PaymentMethodType.CollectVNPayQr: return "Thu hộ VNPayQr";
    }
    return "";
}

export const PAYMENT_METHODS = [
    PaymentMethodType.All,
    PaymentMethodType.Bank,
    PaymentMethodType.CentralPaid,
    PaymentMethodType.HomePay,
    PaymentMethodType.EWallet,
    PaymentMethodType.Manual,
    PaymentMethodType.Transfer,
    PaymentMethodType.Debtminusdeposit,
    PaymentMethodType.CollectVNPayQr,
]